import { render, staticRenderFns } from "./IconLoader.vue?vue&type=template&id=7d90f3c6&scoped=true"
var script = {}
import style0 from "./IconLoader.vue?vue&type=style&index=0&id=7d90f3c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d90f3c6",
  null
  
)

export default component.exports